import { Quote } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const PHOTOS = [
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MTIyMDg0Nnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMGhlYWRzaG90JTIwc21pbGluZ3xlbnwwfHx8fDE3OTA3MzUwODl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MTIyMDg0Nnww&ixlib=rb-4.1.0&q=85",
];

export default function Testimonials() {
  const { t } = useLang();
  const s = t.testimonials;
  return (
    <section id="testimonials" data-testid="testimonials-section" className="section-y bg-cream-100">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="hairline" />
            <span className="text-overline">{s.overline}</span>
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-ink-900 tracking-tight">
            {s.h2a}{" "}
            <span className="text-brand-500">{s.h2accent}</span>{s.h2b}
          </h2>
        </div>

        <div className="mt-16 grid lg:grid-cols-3 gap-6">
          {s.items.map((it, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i + 1}`}
              className="relative bg-white border border-ink-900/8 p-8 sm:p-10 hover:border-brand-500 hover:-translate-y-1 transition-all duration-500 shadow-sm"
            >
              <Quote className="w-7 h-7 text-brand-500" strokeWidth={1.8} />
              <blockquote className="mt-5 font-display font-medium text-lg leading-relaxed text-ink-900">
                &ldquo;{it.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-ink-900/8">
                <img
                  src={PHOTOS[i]}
                  alt={`${it.name} portrait`}
                  className="w-12 h-12 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-semibold text-ink-900">{it.name}</div>
                  <div className="text-xs text-ink-500 mt-0.5">{it.role}</div>
                  <div data-testid={`testimonial-disclaimer-${i + 1}`} className="text-[10px] text-ink-500/60 mt-1 italic leading-snug">{s.disclaimer}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
